import Service from '../abstract/service'
import Empresa from '../empresa'

export default class Consorcio extends Service {
  constructor() {
    super()
    this._consorcioRef = this._db.collection(
      `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Planos`
    )
    this._dataSyncRef = this._db.collection(
      `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/DataSync`
    )
    this._serviceEmpresa = new Empresa()
  }

  async getByEmpresas(empresas) {
    try {
      this._loading.setLoading(true, 'Carregando dados')
      const response = await this._consorcioRef
        .where('empresas', 'array-contains-any', empresas)
        .get()

      let consorcios = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          consorcios.push({
            id: doc.id,
            ...doc.data()
          })
        }
      }

      return Promise.resolve(consorcios)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getByAtivo(ativo) {
    try {
      this._loading.setLoading(true, 'Carregando dados')
      const response = await this._consorcioRef
        .where('ativo', '==', ativo)
        .get()

      let consorcios = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          consorcios.push({
            id: doc.id,
            ...doc.data()
          })
        }
      }

      return Promise.resolve(consorcios)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async criaHistoricoAtualizacaoAtivo(consorcio, usuario) {
    try {
      this._loading.setLoading(true, 'Salvando dados')
      this._historicoRef = this._db.collection(
        `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Planos/${consorcio.id}/historicoAtualizacaoAtivo`
      )
      let acao = 'desativar'
      if (consorcio.ativo) {
        acao = 'ativar'
      }
      await this._historicoRef.doc().set({
        data: new Date(),
        usuario,
        acao
      })

      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async desativaSincronizacaoAntiga() {
    try {
      const response = await this._dataSyncRef.where('ativo', '==', true)
        .where('descricao', '==', 'Consorcio')
        .get()
      if (!response.empty) {
        const [doc] = response.docs
        const sincAntiga = await this._dataSyncRef.doc(doc.id)
        await sincAntiga.update({ ativo: false })
      }
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async criaSincronizacao(fabricante) {
    try {
      const empresas = await this._serviceEmpresa.getByFabricante(fabricante)
      this._loading.setLoading(true, 'Gerando Sincronização')

      await this.desativaSincronizacaoAntiga()
      await this._dataSyncRef.doc().set({
        ativo: true,
        dataCriacao: new Date(),
        descricao: 'Consorcio',
        empresas: empresas.map(empresa => empresa.cnpj)
      })
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async create(consorcio) {
    try {
      console.log(consorcio);
      this._loading.setLoading(true, 'Salvando dados')
      let doc = await this._consorcioRef.doc()
      const {
        ativo,
        descricao,
        coeficienteCotaRepo,
        emplacamento,
        empresas,
        veiculos,
        dataCriacao
      } = consorcio
      await doc.set({
        ativo,
        descricao,
        coeficienteCotaRepo,
        emplacamento,
        empresas,
        veiculos,
        dataCriacao
      })
      consorcio.id = doc.id

      return Promise.resolve(consorcio)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async update(consorcio) {
    try {
      this._loading.setLoading(true, 'Atualizando dados')
      const response = await this._consorcioRef.doc(consorcio.id)
      delete consorcio.id
      response.update(consorcio)

      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }
}
